<template>
  <GlobalAlertWindow
    v-loading="isUploading"
    :title="title"
    :visible.sync="visible"
    :confirm-working="isWorking"
    @confirm="confirm"
  >
    <el-form :model="form" ref="form" :rules="rules" label-width="125px" label-suffix="：" inline>
      <el-form-item label="机构登陆账号" prop="loginname">
        <el-input v-model="form.loginname" :disabled="isEdit" placeholder="请输入登陆账号" v-trim/>
      </el-form-item>
      <el-form-item label="机构名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入机构名称" v-trim/>
      </el-form-item>
      <el-form-item label="机构LOGO" prop="imgurlfull">
        <UploadAvatarImage
          :file="{ 'imgurlfull': form.imgurlfull, 'imgurl': form.imgurl }"
          :uploadData="uploadData"
          @uploadSuccess="uploadIdcardImgSuccess"
          @uploadEnd="isUploading = false"
          @uploadBegin="isUploading = true"
        />
      </el-form-item>
      <el-form-item label="机构地址" prop="addr">
        <el-input v-model="form.addr" placeholder="请输入机构地址" v-trim/>
      </el-form-item>
      <el-form-item label="机构介绍" prop="info">
        <el-input v-model="form.info" placeholder="请输入机构介绍" v-trim/>
      </el-form-item>
      <el-form-item label="关联系统用户" prop="memberId">
        <el-select
          v-model="form.memberId"
          placeholder="请输入会员昵称/手机号，再选择"
          filterable
          remote
          reserve-keyword
          :remote-method="remoteMethod"
          :loading="searchLoading"
        >
          <el-option
            v-for="item in users"
            :key="item.id"
            :label="item.nickname"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
  </GlobalAlertWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalAlertWindow from '@/components/common/GlobalAlertWindow'
import UploadAvatarImage from '@/components/common/UploadAvatarImage'
import { findAll } from '@/api/business/member'
export default {
  name: 'OperaOrgsWindow',
  extends: BaseOpera,
  components: { GlobalAlertWindow, UploadAvatarImage },
  data () {
    return {
      isUploading: false,
      searchLoading: false,
      uploadData: {
        folder: 'member'
      },
      isEdit: false,
      // 表单数据
      form: {
        id: null,
        loginname: '',
        imgurlfull: '',
        name: '',
        imgurl: '',
        addr: '',
        info: '',
        memberId: ''
      },
      users: [],
      // 验证规则
      rules: {
        loginname: [
          { required: true, message: '请输入登陆账号', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入机构名称', trigger: 'blur' }
        ],
        imgurlfull: [
          { required: true, message: '请选择机构LOGO', trigger: 'change' }
        ],
        memberId: [
          { required: true, message: '请选择关联用户', trigger: 'change' }
        ]
      }
    }
  },
  created () {
    this.config({
      api: '/business/orgs',
      'field.id': 'id'
    })
  },
  methods: {
    open (title, target) {
      this.title = title
      this.visible = true
      this.isEdit = false
      this.form.imgurlfull = ''
      this.form.imgurl = ''
      // 新建
      if (target == null) {
        this.$nextTick(() => {
          this.$refs.form.resetFields()
          this.form[this.configData['field.id']] = null
        })
        return
      }
      // 编辑
      this.$nextTick(() => {
        this.isEdit = true
        for (const key in this.form) {
          this.form[key] = target[key]
        }
        this.form.imgurlfull = target.imgFullUrl + target.imgurl
        this.remoteMethod(target.nikeName)
      })
    },
    remoteMethod(query) {
      debugger
      if (query !== '') {
        this.searchLoading = true
        findAll({
          capacity: 999,
          model: {
            nickname: query,
            status: 0
          }
        })
          .then(res => {
            this.users = res
          })
          .finally(() => {
            this.searchLoading = false
          })
      }
    }, 
    uploadIdcardImgSuccess(file) {
      this.form.imgurlfull = file.imgurlfull
      this.form.imgurl = file.imgurl
    }
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/alertstyle.scss";
::v-deep .el-select {
  width: 100%;
  .el-input__inner {
    width: 100%;
  }
}
</style>
